"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var labelStyle = hs_web_style_guide_1.css({
  fontSize: 16,
  color: colors_1.tundora,
  marginBottom: 3
});
var sublabelStyle = hs_web_style_guide_1.css({
  fontSize: 14,
  color: colors_1.silverChalice
});

function MediumLabelSublabel(props) {
  var label = props.label,
      sublabel = props.sublabel;
  return React.createElement("div", null, React.createElement("div", __assign({}, labelStyle, font_1.bold), label), React.createElement("div", __assign({}, sublabelStyle, font_1.regular), sublabel));
}

exports.MediumLabelSublabel = MediumLabelSublabel;